
<div v-show="parentContainer.pageCount > 1" class="rfp-ratings-carousel-pagination">
  <div class="rfp-ratings-carousel-dot-container">
    <div
      v-for="(page, index) in parentContainer.pageCount"
      :key="index"
      class="rfp-ratings-carousel-dot"
      :class="{ 'rfp-ratings-carousel-dot--active': index === parentContainer.currentPage }"
      :style="`
        margin-top: ${parentContainer.paginationPadding * 2}px;
        padding: ${parentContainer.paginationPadding}px;
      `"
      @click="parentContainer.goToPage(index)"
    >
      <div
        class="rfp-ratings-carousel-dot-inner"
        :style="`
          width: ${parentContainer.paginationSize}px;
          height: ${parentContainer.paginationSize}px;
          background: ${index === parentContainer.currentPage ? parentContainer.paginationActiveColor : parentContainer.paginationColor};
        `"
      ></div>
    </div>
  </div>
</div>
